import * as React from 'react'

import { useRepoReplicacheSyncStateStore } from '~/app/(dash)/[team-slug]/header/repo-replicache-sync-state-provider'
import { useRepoReplicache } from './use-repo-replicache'

export const useWaitForNextPull_repoReplicache = () => {
  const replicache = useRepoReplicache().data?.replicache
  const isSaving = useRepoReplicacheSyncStateStore((s) => s.isSaving)
  const [done, setDone] = React.useState(false)
  const [canStartNewPull, setCanStartNewPull] = React.useState(false)

  React.useEffect(() => {
    if (isSaving === false) {
      setCanStartNewPull(true)
    }
  }, [isSaving])

  React.useEffect(() => {
    if (!replicache || !canStartNewPull) return

    replicache.pull()

    const unsub = replicache.experimentalWatch(() => {
      setDone(true)
    })

    return () => unsub()
  }, [replicache, canStartNewPull])

  return done
}
